import { apiClient } from "../lib/apiClient";

export interface ThemeColors {
  primary: string;
  secondary: string;
  accent: string;
  text: string;
  primaryGradientStart: string;
  primaryGradientEnd: string;
  secondaryGradientStart: string;
  secondaryGradientEnd: string;
}

export interface Theme extends ThemeColors {
  id?: string;
  store_id?: string;
  primary_gradient_start: string;
  primary_gradient_end: string;
  secondary_gradient_start: string;
  secondary_gradient_end: string;
  created_at?: string;
  updated_at?: string;
}

export interface CreateThemeRequest {
  primary: string;
  secondary: string;
  accent: string;
  text: string;
  primary_gradient_start: string;
  primary_gradient_end: string;
  secondary_gradient_start: string;
  secondary_gradient_end: string;
}

export class ThemeService {
  static async createTheme(colors: ThemeColors): Promise<Theme> {
    const requestData: CreateThemeRequest = {
      primary: colors.primary,
      secondary: colors.secondary,
      accent: colors.accent,
      text: colors.text,
      primary_gradient_start: colors.primaryGradientStart,
      primary_gradient_end: colors.primaryGradientEnd,
      secondary_gradient_start: colors.secondaryGradientStart,
      secondary_gradient_end: colors.secondaryGradientEnd,
    };

    const response = await apiClient.post<{ data: Theme }>(
      "/api/v1/admin/:storeId/web-builder/site/theme",
      requestData,
    );
    return response.data.data;
  }

  static async getTheme(): Promise<ThemeColors | null> {
    try {
      const response = await apiClient.get<{ data: Theme }>(
        "/api/v1/admin/:storeId/web-builder/site/theme",
      );

      const theme = response.data.data;
      return {
        primary: theme.primary,
        secondary: theme.secondary,
        accent: theme.accent,
        text: theme.text,
        primaryGradientStart: theme.primary_gradient_start,
        primaryGradientEnd: theme.primary_gradient_end,
        secondaryGradientStart: theme.secondary_gradient_start,
        secondaryGradientEnd: theme.secondary_gradient_end,
      };
    } catch {
      // If no theme exists, return null
      return null;
    }
  }

  static async updateTheme(colors: ThemeColors): Promise<Theme> {
    const requestData: CreateThemeRequest = {
      primary: colors.primary,
      secondary: colors.secondary,
      accent: colors.accent,
      text: colors.text,
      primary_gradient_start: colors.primaryGradientStart,
      primary_gradient_end: colors.primaryGradientEnd,
      secondary_gradient_start: colors.secondaryGradientStart,
      secondary_gradient_end: colors.secondaryGradientEnd,
    };

    const response = await apiClient.put<{ data: Theme }>(
      "/api/v1/admin/:storeId/web-builder/site/theme",
      requestData,
    );
    return response.data.data;
  }
}
